import { Box, type TypographyProps } from "@mui/material";
import { PaperTitle } from "Components/Shared/PaperTitle";
import type { ReactNode } from "react";

type FormSectionProps = {
  legend?: string;
  legendProps?: TypographyProps;
  children: ReactNode;
  noMargins?: boolean;
};

export const FormSection = ({
  legend,
  legendProps,
  children,
  noMargins,
}: FormSectionProps) => (
  <Box
    component="fieldset"
    sx={{ all: "unset", display: "grid", mb: noMargins ? 0 : 4 }}
  >
    {legend && (
      <PaperTitle component="legend" mb={2} p={0} {...legendProps}>
        {legend}
      </PaperTitle>
    )}
    {children}
  </Box>
);
